import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestsEmptyState, IRequestsState } from './RequestsState';
import {
  createRequest,
  fetchAgencyCount,
  fetchIncidents,
  fetchMaxRequestNumber,
  changeRequest,
} from './requestsThunk';
import { QueryState } from 'common/enums';
import { RequestFormData } from '../../../pages/Dashboard/ResourceRequest/hooks/useRequestForm';

const initialState: IRequestsState = RequestsEmptyState;

export const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    updateRequestForm: (state, action: PayloadAction<{ data: RequestFormData }>) => {
      state.requestForm = action.payload.data;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(createRequest.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.state = QueryState.AWAIT;
      })
      .addCase(createRequest.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.state = QueryState.CREATED;
      })
      .addCase(createRequest.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong!';
      })
      .addCase(fetchAgencyCount.fulfilled, (state, action) => {
        state.agencyCount = action.payload || state.agencyCount;
      })
      .addCase(fetchMaxRequestNumber.fulfilled, (state, action) => {
        state.newRequestNumber = action.payload;
      })
      .addCase(changeRequest.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.state = QueryState.AWAIT;
      })
      .addCase(changeRequest.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.state = QueryState.UPDATED;
      })
      .addCase(changeRequest.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.error.message;
        state.state = QueryState.FAIL;
      })
      .addCase(fetchIncidents.fulfilled, (state, action) => {
        state.incidents = action.payload;
      });
  },
});

export const { resetState, updateRequestForm } = requestsSlice.actions;

export default requestsSlice.reducer;
